module.exports = __webpack_public_path__ + "angola.svg?c4defe745facdf368cb0b560077213bf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/angola.svg
// module id = 91
// module chunks = 10